"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = void 0;

var Profile =
/** @class */
function () {
  function Profile(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - profileId
   * @return Promise|Observable|any
   */


  Profile.prototype.GetProfile = function (profileId) {
    return this.restClient.get('Profile/UseCase/GetProfile', {
      profileId: profileId
    });
  };
  /**
   * @param string - eventId
   * @param string[] - withData EventProfiles|ProfileLinks
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-500
   * @param string? - sortBy name|title|company|created
   * @param string? - sortDirection ascending|descending
   * @param string? - query
   * @param boolean? - shouldHideDeleted true|false
   * @param any[]? - eventProfileTypeFilter speaker|presenter|sponsor|panelist|moderator|host|participant|other
   * @return Promise|Observable|any
   */


  Profile.prototype.ListProfilesForEvent = function (eventId, withData, page, itemsPerPage, sortBy, sortDirection, query, shouldHideDeleted, eventProfileTypeFilter) {
    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (query === void 0) {
      query = null;
    }

    if (shouldHideDeleted === void 0) {
      shouldHideDeleted = null;
    }

    if (eventProfileTypeFilter === void 0) {
      eventProfileTypeFilter = null;
    }

    return this.restClient.get('Profile/UseCase/ListProfilesForEvent', {
      eventId: eventId,
      withData: withData,
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy: sortBy,
      sortDirection: sortDirection,
      query: query,
      shouldHideDeleted: shouldHideDeleted,
      eventProfileTypeFilter: eventProfileTypeFilter
    });
  };
  /**
   * @param string - poolId
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-500
   * @param string? - sortBy
   * @param string? - sortDirection ascending|descending
   * @return Promise|Observable|any
   */


  Profile.prototype.ListProfilesForPool = function (poolId, page, itemsPerPage, sortBy, sortDirection) {
    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    return this.restClient.get('Profile/UseCase/ListProfilesForPool', {
      poolId: poolId,
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  }; // Commands

  /**
   * @param string - profileId
   * @param string - eventId
   * @param string - eventProfileType speaker|presenter|sponsor|panelist|moderator|host|participant|other
   * @return Promise|Observable|any
   */


  Profile.prototype.AddProfileToEvent = function (profileId, eventId, eventProfileType) {
    return this.restClient.post('Profile/UseCase/AddProfileToEvent', {
      profileId: profileId,
      eventId: eventId,
      eventProfileType: eventProfileType
    });
  };
  /**
   * @param string - eventId
   * @param any[] - eventProfiles
   * @return Promise|Observable|any
   */


  Profile.prototype.AddProfilesToEvent = function (eventId, eventProfiles) {
    return this.restClient.post('Profile/UseCase/AddProfilesToEvent', {
      eventId: eventId,
      eventProfiles: eventProfiles
    });
  };
  /**
   * @param string - poolId
   * @param string? - firstName
   * @param string? - lastName
   * @param string? - company
   * @param string? - emailAddress
   * @param string? - title
   * @param string? - description
   * @param string? - imageUrl
   * @param string? - profileType person|company|other
   * @param string? - profileId
   * @param string? - eventId
   * @param string? - eventProfileType
   * @return Promise|Observable|any
   */


  Profile.prototype.CreateProfile = function (poolId, firstName, lastName, company, emailAddress, title, description, imageUrl, profileType, profileId, eventId, eventProfileType) {
    if (firstName === void 0) {
      firstName = null;
    }

    if (lastName === void 0) {
      lastName = null;
    }

    if (company === void 0) {
      company = null;
    }

    if (emailAddress === void 0) {
      emailAddress = null;
    }

    if (title === void 0) {
      title = null;
    }

    if (description === void 0) {
      description = null;
    }

    if (imageUrl === void 0) {
      imageUrl = null;
    }

    if (profileType === void 0) {
      profileType = null;
    }

    if (profileId === void 0) {
      profileId = null;
    }

    if (eventId === void 0) {
      eventId = null;
    }

    if (eventProfileType === void 0) {
      eventProfileType = null;
    }

    return this.restClient.post('Profile/UseCase/CreateProfile', {
      poolId: poolId,
      firstName: firstName,
      lastName: lastName,
      company: company,
      emailAddress: emailAddress,
      title: title,
      description: description,
      imageUrl: imageUrl,
      profileType: profileType,
      profileId: profileId,
      eventId: eventId,
      eventProfileType: eventProfileType
    });
  };
  /**
   * @param string - profileId
   * @return Promise|Observable|any
   */


  Profile.prototype.DeleteProfile = function (profileId) {
    return this.restClient.post('Profile/UseCase/DeleteProfile', {
      profileId: profileId
    });
  };
  /**
   * @param string - profileId
   * @return Promise|Observable|any
   */


  Profile.prototype.RemoveProfile = function (profileId) {
    return this.restClient.post('Profile/UseCase/RemoveProfile', {
      profileId: profileId
    });
  };
  /**
   * @param string - profileId
   * @param string - eventId
   * @return Promise|Observable|any
   */


  Profile.prototype.RemoveProfileFromEvent = function (profileId, eventId) {
    return this.restClient.post('Profile/UseCase/RemoveProfileFromEvent', {
      profileId: profileId,
      eventId: eventId
    });
  };
  /**
   * @param string - profileId
   * @param string - company
   * @return Promise|Observable|any
   */


  Profile.prototype.SetCompany = function (profileId, company) {
    return this.restClient.post('Profile/UseCase/SetCompany', {
      profileId: profileId,
      company: company
    });
  };
  /**
   * @param string - profileId
   * @param string - description
   * @return Promise|Observable|any
   */


  Profile.prototype.SetDescription = function (profileId, description) {
    return this.restClient.post('Profile/UseCase/SetDescription', {
      profileId: profileId,
      description: description
    });
  };
  /**
   * @param string - profileId
   * @param string? - firstName
   * @param string? - lastName
   * @return Promise|Observable|any
   */


  Profile.prototype.SetName = function (profileId, firstName, lastName) {
    if (firstName === void 0) {
      firstName = null;
    }

    if (lastName === void 0) {
      lastName = null;
    }

    return this.restClient.post('Profile/UseCase/SetName', {
      profileId: profileId,
      firstName: firstName,
      lastName: lastName
    });
  };
  /**
   * @param string - profileId
   * @param string - profileType
   * @return Promise|Observable|any
   */


  Profile.prototype.SetProfileType = function (profileId, profileType) {
    return this.restClient.post('Profile/UseCase/SetProfileType', {
      profileId: profileId,
      profileType: profileType
    });
  };
  /**
   * @param string - eventProfileId
   * @param string - eventProfileType speaker|presenter|sponsor|panelist|moderator|host|participant|other
   * @return Promise|Observable|any
   */


  Profile.prototype.UpdateEventProfileType = function (eventProfileId, eventProfileType) {
    return this.restClient.post('Profile/UseCase/UpdateEventProfileType', {
      eventProfileId: eventProfileId,
      eventProfileType: eventProfileType
    });
  };
  /**
   * @param string - profileId
   * @param string? - poolId
   * @param string? - firstName
   * @param string? - lastName
   * @param string? - company
   * @param string? - emailAddress
   * @param string? - title
   * @param string? - description
   * @param string? - imageUrl
   * @param string? - profileType person|company|other
   * @return Promise|Observable|any
   */


  Profile.prototype.UpdateProfile = function (profileId, poolId, firstName, lastName, company, emailAddress, title, description, imageUrl, profileType) {
    if (poolId === void 0) {
      poolId = null;
    }

    if (firstName === void 0) {
      firstName = null;
    }

    if (lastName === void 0) {
      lastName = null;
    }

    if (company === void 0) {
      company = null;
    }

    if (emailAddress === void 0) {
      emailAddress = null;
    }

    if (title === void 0) {
      title = null;
    }

    if (description === void 0) {
      description = null;
    }

    if (imageUrl === void 0) {
      imageUrl = null;
    }

    if (profileType === void 0) {
      profileType = null;
    }

    return this.restClient.post('Profile/UseCase/UpdateProfile', {
      profileId: profileId,
      poolId: poolId,
      firstName: firstName,
      lastName: lastName,
      company: company,
      emailAddress: emailAddress,
      title: title,
      description: description,
      imageUrl: imageUrl,
      profileType: profileType
    });
  };

  return Profile;
}();

exports.Profile = Profile;